import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useGetTransactionsStore } from '@lib/store';
import { AmountUtils } from '@shared/utils';
import type { GetTransactionsResponse } from '@shared/api/rest/accounts';
import { PrintInfoModal } from './printInfoModal';
import { Table } from '@shared/widgets';
import EllipsisIcon from '@images/ellipsis.svg';

export interface ColumnsType {
  title: string;
  onSort?: () => void;
}

export const PaymentsOverview = () => {
  const { loading, data, get } = useGetTransactionsStore();

  const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransactions] = useState<GetTransactionsResponse>();

  const [sortOrder, setSortOrder] = useState<string>('desc');
  const [sortedData, setSortedData] = useState<GetTransactionsResponse[]>(data);

  useEffect(() => {
    get('c10b71ee-0f03-e711-80c4-00155d5bc507');
  }, []);

  useEffect(() => {
    const sorted = [...data];
    if (sortOrder === 'asc') {
      sorted.sort((a, b) => (dayjs(a.Date).isBefore(dayjs(b.Date)) ? -1 : 1));
    } else if (sortOrder === 'desc') {
      sorted.sort((a, b) => (dayjs(a.Date).isBefore(dayjs(b.Date)) ? 1 : -1));
    }
    setSortedData(sorted);
  }, [data, sortOrder]);

  const handleEllipsisClick = (row: GetTransactionsResponse) => {
    setSelectedTransactions(row);
    setIsVisibleModal(true);
  };

  const handleSort = () => {
    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };

  const COLUMNS: ColumnsType[] = [
    {
      title: 'Registration Date',
      onSort: handleSort,
    },
    { title: 'DESCRIPTION' },
    { title: 'TO/FROM' },
    { title: 'Amount' },
    { title: 'STATUS' },
    { title: 'i' },
  ];

  return (
    <>
      <Table
        className='mt-6.5'
        columns={COLUMNS}
        items={sortedData.map((row) => {
          return [
            { value: row.Date ? dayjs(row.Date).format('DD.MM.YYYY') : '--' },
            { value: row.Description ? row.Description : '--' },
            { value: row.Beneficiary ? row.Beneficiary : '--' },
            { value: row.PaidOut ? `${row.Currency || ''} ${AmountUtils.transformToAmount(row.PaidOut)}` : '--' },
            { value: row.Status ? <div className={`${row.Status === 'Rejected' ? 'text-[#e42d34]' : ''}`}>{row.Status}</div> : '--' },
            { value: <EllipsisIcon className='cursor-pointer fill-[#b9b9b9]' onClick={() => handleEllipsisClick(row)} />, more: true },
          ];
        })}
        loading={loading}
        isScrollable
        sortOrder={sortOrder}
      />
      <PrintInfoModal isOpen={isVisibleModal} onClose={() => setIsVisibleModal(false)} transaction={selectedTransaction} />
    </>
  );
};
